import { useRegisterFormController } from '../../../../hooks/useRegisterFormController';
import type { RegisterFormProps } from '../../../../hooks/registerForm.shared';
import NeobetDynamicFormFields from '../auth/NeobetDynamicFormFields';
import NeobetAuthFormShell from '../auth/NeobetAuthFormShell';

const NeobetRegisterForm = ({ promoCode }: RegisterFormProps) => {
  const { t, control, errors, isSubmitting, fieldsToRender, handleClose, onSubmit, openLoginForm } =
    useRegisterFormController({ promoCode });

  return (
    <div data-testid='neobet-register-form'>
      <NeobetAuthFormShell
        title={t('register.register')}
        submitTitle={t('register.register')}
        onSubmit={onSubmit}
        onClose={handleClose}
        isSubmitting={isSubmitting}
        footerText={t('register.alreadyHaveAccount')}
        footerActionLabel={t('login.title')}
        onFooterAction={openLoginForm}
        footerTestId='neobet-register-form-footer'
        footerActionTestId='neobet-register-form-open-login'
        testId='neobet-register-form'
      >
        <NeobetDynamicFormFields
          fields={fieldsToRender}
          control={control}
          errors={errors}
          isSubmitting={isSubmitting}
        />
      </NeobetAuthFormShell>
    </div>
  );
};

export default NeobetRegisterForm;
